import { DocumentViewerContextType } from '@/types/documentViewerTypes';
import { createContext, useContext } from 'react';

export const DocumentViewerContext = createContext<
	DocumentViewerContextType | undefined
>(undefined);

export const useDocViewerCtx = () =>
	useContext(DocumentViewerContext) as DocumentViewerContextType;
